import { Relatie } from '@/lib/types';
import { Lozingsvorm } from '@/lib/types/relatie';
import { Form } from 'antd';
import { useMemo } from 'react';

export const useHeeftLozing = (teeltwijze: number): boolean => {
  const form = Form.useFormInstance<Relatie>();
  const lozingsVorm = Form.useWatch('lozingsVorm', form) || [];

  return useMemo(
    () =>
      lozingsVorm.some(
        item =>
          item?.betrekkingTotTeeltwijze === teeltwijze &&
          [Lozingsvorm.Riool, Lozingsvorm.Oppervlaktewater, Lozingsvorm.RioolEnOppervlaktewater].includes(item.value)
      ),
    [lozingsVorm, teeltwijze]
  );
};
